import { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { TrashIcon } from '@heroicons/react/24/outline';

const TaskModal = ({ show, handleClose, task, onSave, onDelete, users }) => {
  const [formData, setFormData] = useState({
    title: '',
    assigneeId: '',
    assigneeName: '',
    group: 'Main table',
    status: 'Not Started Yet',
    dueDate: '', 
    link: '',
    notes: ''
  });

  useEffect(() => {
    if (task) {
      setFormData(task);
    } else {
      setFormData({ title: '', assigneeId: '', assigneeName: '', group: 'Main table', status: 'Not Started Yet', dueDate: '', link: '', notes: '' });
    }
  }, [task]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'assigneeId') {
      const selectedUser = users.find(u => u.id === value);
      setFormData(prev => ({ 
        ...prev, 
        assigneeId: value,
        assigneeName: selectedUser ? (selectedUser.displayName || selectedUser.email) : ''
      }));
      return;
    }
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold fs-5">{task ? 'Edit Task' : 'New Task'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="row g-3">
            <Form.Group className="col-md-8">
              <Form.Label className="small text-muted mb-1 fw-bold">Task Title</Form.Label>
              <Form.Control type="text" name="title" value={formData.title} onChange={handleChange} required placeholder="e.g., Connect klarna" className="rounded-3 shadow-sm border-0 bg-light" />
            </Form.Group>

            <Form.Group className="col-md-4">
              <Form.Label className="small text-muted mb-1 fw-bold">Group / Board</Form.Label>
              <Form.Control type="text" name="group" value={formData.group} onChange={handleChange} required placeholder="e.g., Phase 1" className="rounded-3 shadow-sm border-0 bg-light" />
            </Form.Group>
            
            <Form.Group className="col-md-6">
              <Form.Label className="small text-muted mb-1 fw-bold">Person (Required)</Form.Label>
              <Form.Select name="assigneeId" value={formData.assigneeId} onChange={handleChange} required className="rounded-3 shadow-sm border-0 bg-light">
                <option value="" disabled>Select a team member...</option>
                {users.map(user => (
                  <option key={user.id} value={user.id}>{user.displayName || user.email}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="col-md-6">
              <Form.Label className="small text-muted mb-1 fw-bold">Deadline</Form.Label>
              <Form.Control type="datetime-local" name="dueDate" value={formData.dueDate} onChange={handleChange} required className="rounded-3 shadow-sm border-0 bg-light" />
            </Form.Group>

            <Form.Group className="col-md-6">
              <Form.Label className="small text-muted mb-1 fw-bold">Status</Form.Label>
              <Form.Select name="status" value={formData.status} onChange={handleChange} className="rounded-3 shadow-sm border-0 bg-light">
                <option value="Not Started Yet">Not Started Yet</option>
                <option value="Working on it">Working on it</option>
                <option value="Waiting For Info">Waiting For Info</option>
                <option value="Stuck">Stuck</option>
                <option value="Done">Done</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="col-md-6">
              <Form.Label className="small text-muted mb-1 fw-bold">Relevant Link</Form.Label>
              <Form.Control type="url" name="link" value={formData.link || ''} onChange={handleChange} placeholder="https://..." className="rounded-3 shadow-sm border-0 bg-light" />
            </Form.Group>

            <Form.Group className="col-md-12">
              <Form.Label className="small text-muted mb-1 fw-bold">Notes</Form.Label>
              <Form.Control as="textarea" rows={2} name="notes" value={formData.notes} onChange={handleChange} placeholder="Add context..." className="rounded-3 shadow-sm border-0 bg-light" />
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 d-flex justify-content-between">
          <div>
            {task && (
              <Button variant="outline-danger" className="d-flex align-items-center gap-1 btn-sm rounded-pill px-3 border-0 bg-danger text-white bg-opacity-75 hover-opacity-100" onClick={() => onDelete(task.id)}>
                <TrashIcon className="h-4 w-4" style={{width: '16px'}} /> Delete
              </Button>
            )}
          </div>
          <div className="d-flex gap-2">
            <Button variant="light" className="btn-sm rounded-pill px-3" onClick={handleClose}>Cancel</Button>
            <Button variant="primary" type="submit" className="btn-sm rounded-pill px-3" style={{ backgroundColor: '#2d3436', border: 'none' }}>
              {task ? 'Update' : 'Create Task'}
            </Button>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default TaskModal;